import { format, parseISO } from "date-fns";
import { ThreeDots } from "../../../assets/icons/ThreeDots";
import { Archive } from "../../../assets/icons/Archive";
import { Folder } from "../../../assets/icons/Folder";
import { Pen } from "../../../assets/icons/Pen";
import { useRef, useState, useEffect } from "react";
import { ModalManageFolder } from "./modals/ModalManageFolder";
import { ModalDeleteFolder } from "./modals/ModalDeleteFolder";
import { Trash } from "../../../assets/icons/Trash";
import { history } from "../../../store/index";
import CustomTooltip from "../../../common/components/CustomTooltip";
import { isEllipsisActive } from "../../../utils";

const FolderRow = ({ folder, archive, updateFolder, deleteFolder }) => {
  const [isManageFolderModalOpen, setIsManageFolderModalOpen] = useState(false);
  const [isDeleteFolderModalOpen, setIsDeleteFolderModalOpen] = useState(false);
  const nameRef = useRef();
  const [showEllipsisTooltip, setShowEllipsisTooltip] = useState(false);
  // Reset ellipsis state when folder label changes
  useEffect(() => {
    setShowEllipsisTooltip(isEllipsisActive(nameRef));
  }, [folder?.label]);

  const handleFolderClick = () => {
    history.push(`/folders/${archive ? "archives" : folder._id}`);
  };

  return (
    <>
      <tr className="calcul-raw align-items-center">
        <td
          style={{
            width: "100%",
            maxWidth: "1px",
          }}
          data-toggle="dropdown"
          data-tooltip-id={`folder-${folder?._id}`}
          onMouseEnter={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
        >
          <div className=" align-items-center d-flex">
            <div
              className={`folder-table-icon mr-1 ${archive ? "archive" : ""}`}
            >
              {archive ? <Archive size={24} /> : <Folder size={24} />}
            </div>
            <span
              ref={nameRef}
              style={{
                width: "calc(100% - 54px)",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <span onClick={handleFolderClick} className="folder-label">
                {archive ? "Archives" : folder?.label || ""}
              </span>
            </span>
          </div>
          {showEllipsisTooltip && (
            <CustomTooltip
              id={`folder-${folder?._id}`}
              place="bottom"
              dark
              offset={-10}
            >
              <div className="text">
                {archive ? "Archives" : folder?.label || ""}
              </div>
            </CustomTooltip>
          )}
        </td>
        <td
          className="folder-date-col"
          style={{ width: 160, minWidth: 120, maxWidth: 180 }}
        >
          {archive
            ? ""
            : format(parseISO(folder.updatedAt), "dd/MM/yyyy HH:mm")}
        </td>
        <td
          className="dropdown-column"
          style={{ width: 80, minWidth: 60, maxWidth: 100 }}
        >
          {!archive && (
            <div className="dropdown d-flex justify-content-end">
              <button
                className="action-button"
                type="button"
                data-toggle="dropdown"
                data-tooltip-id={`actions-btn${folder._id}`}
                data-tooltip-content={"Autres actions"}
                onMouseUp={(e) => e.currentTarget.blur()}
              >
                <ThreeDots className="text-interaction" />
              </button>
              <CustomTooltip id={`actions-btn${folder._id}`} place="top" />
              <div className="dropdown-menu dropdown-menu-right">
                <li>
                  <button
                    onClick={() => setIsManageFolderModalOpen(true)}
                    className="dropdown-item text-primary-black d-flex align-items-center"
                  >
                    <Pen size={22} />
                    <span style={{ marginLeft: 12 }}> Renommer le dossier</span>
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setIsDeleteFolderModalOpen(true)}
                    className="dropdown-item text-primary-black d-flex align-items-center"
                  >
                    <Trash size={22} />
                    <span style={{ marginLeft: 12 }}>Supprimer le dossier</span>
                  </button>
                </li>
              </div>
            </div>
          )}
        </td>
      </tr>
      <ModalManageFolder
        isOpen={isManageFolderModalOpen}
        onClose={() => setIsManageFolderModalOpen(false)}
        updateFolder={updateFolder}
        folder={folder}
      />
      <ModalDeleteFolder
        isOpen={isDeleteFolderModalOpen}
        onClose={() => setIsDeleteFolderModalOpen(false)}
        deleteFolder={deleteFolder}
        folderId={folder?._id}
      />
    </>
  );
};

export default FolderRow;
